$(document).ready(function(){

   // $('.flexslider').flexslider( {directionNav: false});

    $captions = $('.flexslider-captions');

    $('.flexslider').flexslider({
        animation: "fade",
        controlNav: true,
        controlsContainer: $(".flexslider-controls-container"),
        directionNav: false,
        slideshow: false,
        prevText: "Previous",
        nextText: "Next",
        useCSS: true,
        touch: true,
        start: function() {
            $activecaption = $('.flex-active-slide .slide-info');
            $captions.html($activecaption.html());        
        },
        before: function(){
            $captions.fadeOut(); 
        },
        after: function() {
            $activecaption = $('.flex-active-slide .slide-info');
            $captions.html($activecaption.html()).fadeIn();
        }
    });    

    $('.product-search > li').click(function(){        
        $('.filter-panel').slideUp();

        if($(this).children('.filter-panel').is(':hidden')){
            $(this).children('.filter-panel').slideDown();
        }
    });

    $('.panel-toggle').click(function(){
        $('.product-info-panel').removeClass('active');
        $(this).siblings('.product-info-panel').addClass('active');

    });

    $('#product-filter-form li a.filter').click(function(e){
        e.preventDefault();
        e.stopPropagation();
        var filtertype = $(this).data('filtertype');
        var value = $(this).data('filter');
    
        if($('#'+filtertype).val() !== value){
          $('#'+filtertype).val(value);
        }
        else{
          $('#'+filtertype).val('');
        }
    
        $('#product-filter-form').submit();
    
      });

      $('.show-more').click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(".filter-panel-collections a:hidden").slice(0,10).fadeIn();

        if(!$(".filter-panel-collections a:hidden").length){
            $(this).hide();
        }
      });
        
      $('.post-type-archive-product a.page-numbers').click(function(e){
        e.preventDefault();
    
        var href = $(this).attr('href');
        var pNum = href.split('?page=').pop();
    
        $('#product-filter-form #page').val(pNum);
        $('#product-filter-form').submit();
    
      });

    $('.close-panel').click(function(){
        $('.product-info-panel').removeClass('active');
    });

	if($('.flipbook').length>0){
	    $('.flipbook').turn({
	        // Width
	
	        width:922,
	        
	        // Height
	
	        height:600,
	
	        // Elevation
	
	        elevation: 50,
	        
	        // Enable gradients
	
	        gradients: true,
	        
	        // Auto center this flipbook
	
	        autoCenter: true
	
		});
	}
	
	var scrollToTarget = function (tgtEl, siteHeader, scrollSpeed) {
            if (scrollSpeed === undefined) { scrollSpeed = 500 };
            // is header fixed?
            hoffset = 0;
            if (siteHeader !== undefined) {
                if (siteHeader.css('position') == 'fixed') {
                    hoffset = siteHeader.height();
                }
            }
            if (tgtEl.parent().css('display') !== 'none') {
                scrollToHere = tgtEl.offset().top - hoffset;
                $('html, body').animate({
                    scrollTop: scrollToHere
                }, scrollSpeed);
            }
        }
	
   var scrollToTargetIni = function () {
     
        $('a.scrollToTgt[href^="#"]').on('click', function (e) {
            e.preventDefault();
            if ($(this).attr('href').length > 1) {
                if($(this).attr('href')==='#back_to_top'){
                    tgtEl=$('body');
                }else{
                    tgtEl = $($(this).attr('href'));
                }
                scrollSpeed = 500;
                siteHeader = $('header.site-header');
                
                scrollToTarget(tgtEl, siteHeader, scrollSpeed);
            }
        });

    }
    scrollToTargetIni();
    
    
    var headerheight;
    var fixEl = $('.fixMeOnScroll');
    var fixElWidth= fixEl.outerWidth(true)+'px';
    var myHeader = $('.work-content .entry-header.archive-header');
    var myHeaderHeight =  myHeader.outerHeight(true);
    fixEl.after('<div class="fixedSpacer hidden" style="width:40%; height:'+fixEl.outerHeight(true)+'px;opacity:0; float:left; display:inline-block;"></div>');
     
    var doOnScroll = function(){
        var scrollPercentage = 100 * ($(window).scrollTop() / $('body').height()),
            scrollNumber = ($(window).scrollTop());        

        if($('.header').outerHeight(true)!== undefined){
            headerheight = $('.header').outerHeight(true);
        }

        if($('#product-filter-form').length){
            var collections = $('.collections-ctn').height();
            var rightpanel = $('.right-panel').height();

            var filterTop = $('#product-filter-form').offset().top;

            var leftfilter = $('#product-filter-form').height();
            if(scrollNumber >= filterTop){

                if((scrollNumber - headerheight )>= (collections - 100)) {
                     $('.search-bar').addClass('bottom');
                }else{
                    $('.search-bar').removeClass('bottom');
                }

                if(rightpanel >= leftfilter){
                    $('.search-bar').addClass('fixed');
                    $('.search-bar').css('width',$('#product-filter-form').outerWidth()+'px');
                }

            }
            else{
                $('.search-bar').removeClass('fixed');
                $('.search-bar').css('width','inherit');
            }
        }
        
        //if($('.header').hasClass('site-navigation-fixed') && $(window).width()>767){
        if($(window).scrollTop()>headerheight){
            myHeaderHeight =  myHeader.outerHeight(true);
           // myHeader.css({'position':'fixed','background':'#fff','z-index':'100','top':headerheight+'px','padding-top':'15px'});
            fixEl.css({'position':'fixed','width': fixElWidth,'top':'80px','z-index':'900'});
            $('.fixedSpacer').css({'width':'40%','height':fixEl.outerHeight(true)+'px'}).removeClass('hidden');

        } else {
            
            myHeader.css({'position':'','background':'','z-index':'','top':'','padding-top':''});
            
            fixEl.css({'position':'','top':'','width':''});
            fixElWidth= fixEl.outerWidth(true)+'px';
            $('.fixedSpacer').addClass('hidden');
        }


    };
    doOnScroll();

    var doOnResize = function(){
        fixElStyles=fixEl.attr('style');
        fixEl.attr('style','');
        fixEl.css({'position':'','top':'','width':''});
        fixElWidth= fixEl.outerWidth(true)+'px';
        fixEl.attr('style',fixElStyles);
        fixEl.css('width',fixElWidth);

        
        $('.search-bar').css('width',$('#product-filter-form').outerWidth()+'px');

        if($(window).width()<768){
           // myHeader.css({'position':'','background':'','z-index':'','top':'','padding-top':''});
            fixEl.css({'position':'','top':'','width':''});
            fixElWidth= fixEl.outerWidth(true)+'px';
            $('.fixedSpacer').addClass('d-none');
        }
    };

    // Scroll listener
    // For fixed header
    $(window).on('scroll',function(){
        doOnScroll();
    });
    $(window).on('resize',function(){
        doOnResize();
    });


    // Quick Find modal pop on category page
    if (window.location.search.indexOf('vid') > -1) {
        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            return results[1] || 0;
        }
        var varientid = $.urlParam('vid');

        $('#product'+ varientid +'Modal').modal('show');
    }

    $('.filter-bar a.filter').click(
        function(){
            var id = $(this).data('id');
            console.log(id);

            $('#'+id).val('');

            $('#product-filter-form').submit();
        }
    );

   /* $('.collapse').on('hide.bs.collapse', function () {
        $(this).siblings().find('.plus').show();
        $(this).siblings().find('.minus').hide();
      });

      $('.collapse').on('show.bs.collapse', function () {
          $(this).siblings().find('.plus').hide();
          $(this).siblings().find('.minus').show();
        });*/

    let popupClose = $('.close-popup');

    if (popupClose) {
        popupClose.on('click',function() {
            $('.checkout-popup-container').removeClass('show-popup');
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/scripts/parts/site.js
// module id = 16
// module chunks = 0